// import React from "react";
import { useState } from "react"
import styles from "./PaginationComponent.module.scss"
import { BsArrowLeft, BsArrowRight } from "react-icons/bs"
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap"

const PaginationComponent = ({ rowsPerPage, rowCount, onChangePage, currentPage, onChangeRowsPerPage }) => {
  const totalPages = Math.ceil(rowCount / rowsPerPage)

  const [dropdownOpen, setDropdownOpen] = useState(false)
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen)

  const perPageOptions = [3, 5, 10, 15, 20]

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      onChangePage(page)
    }
  }

  // const handleRowsChange = (event) => {
  //   onChangeRowsPerPage(Number(event.target.value))
  // }

  const renderPageTabs = () => {
    const pages = []

    if (totalPages <= 4) {
      // Show all pages if 4 or fewer
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <button key={i} className={`${styles.tab} ${currentPage === i ? styles.active : ""}`} onClick={() => handlePageChange(i)}>
            {i}
          </button>
        )
      }
    } else {
      // Show first 3 pages, ellipsis, and last page
      if (currentPage <= 3) {
        for (let i = 1; i <= 3; i++) {
          pages.push(
            <button key={i} className={`${styles.tab} ${currentPage === i ? styles.active : ""}`} onClick={() => handlePageChange(i)}>
              {i}
            </button>
          )
        }
        pages.push(
          <span key="ellipsis" className={styles.ellipsis}>
            ...
          </span>
        )
        pages.push(
          <button key={totalPages} className={`${styles.tab} ${currentPage === totalPages ? styles.active : ""}`} onClick={() => handlePageChange(totalPages)}>
            {totalPages}
          </button>
        )
      } else if (currentPage > totalPages - 3) {
        pages.push(
          <button key={1} className={`${styles.tab} ${currentPage === 1 ? styles.active : ""}`} onClick={() => handlePageChange(1)}>
            1
          </button>
        )
        pages.push(
          <span key="ellipsis" className={styles.ellipsis}>
            ...
          </span>
        )
        for (let i = totalPages - 2; i <= totalPages; i++) {
          pages.push(
            <button key={i} className={`${styles.tab} ${currentPage === i ? styles.active : ""}`} onClick={() => handlePageChange(i)}>
              {i}
            </button>
          )
        }
      } else {
        pages.push(
          <button key={1} className={`${styles.tab} ${currentPage === 1 ? styles.active : ""}`} onClick={() => handlePageChange(1)}>
            1
          </button>
        )
        pages.push(
          <span key="ellipsis" className={styles.ellipsis}>
            ...
          </span>
        )
        pages.push(
          <button key={currentPage} className={`${styles.tab} ${styles.active}`} onClick={() => handlePageChange(currentPage)}>
            {currentPage}
          </button>
        )
        pages.push(
          <span key="ellipsis2" className={styles.ellipsis}>
            ...
          </span>
        )
        pages.push(
          <button key={totalPages} className={`${styles.tab}`} onClick={() => handlePageChange(totalPages)}>
            {totalPages}
          </button>
        )
      }
    }

    return pages
  }

  return (
    <div className={styles.paginationContainer}>
      <div className={styles.paginationControls}>
        <button
          className={`${styles.navButton} ${currentPage === 1 ? styles.disabled : ""}`}
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <BsArrowLeft /> Prev
        </button>

        {renderPageTabs()}

        <button
          className={`${styles.navButton} ${currentPage === totalPages ? styles.disabled : ""}`}
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next <BsArrowRight />
        </button>
      </div>

      <div>
        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} className={styles.actionDropdown}>
          <DropdownToggle caret className={styles.dropdownButton}>
            {rowsPerPage} per page
          </DropdownToggle>
          <DropdownMenu className={styles.dropDownMenu}>
            {perPageOptions.map((value) => (
              <DropdownItem className={styles.dropdownItem} key={value} onClick={() => onChangeRowsPerPage(value)}>
                {value} per page
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>
  )
}

export default PaginationComponent
